const locations = {
    Lobith: 'Lobith',
    SintPieter: 'Sint Pieter',
}

export default locations;